import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../Pages/Shared/Footers/Small-Footer';
import Header from '../Pages/Shared/Headers/Header';
import SectionGridLines from '../components/SectionGridLines';
import Home01 from '../Pages/HomePages/Home01';
import { useResponsive } from '../contexts/ResponsiveContext';
import TestMobileMenu from '../components/TestMobileMenu';

const HomeLayout = () => {
    const location = useLocation();
    const { isMobile } = useResponsive();
    const [menuVisible, setMenuVisible] = useState(true);
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    
    // Add paths where you don't want the footer to appear
    const noFooterPaths = [
        // add other paths as needed
    ];

    const shouldShowFooter = !noFooterPaths.includes(location.pathname);

    // Reset menu state when location changes
    useEffect(() => {
        // Close mobile menu when navigating to a new page
        setMenuOpen(false);
        
        // Reset body transform that might have been applied by the mobile menu
        document.body.style.transform = 'translateX(0)';
        document.body.style.transition = '';
    }, [location.pathname]);

    // Update menu visibility based on mobile state
    useEffect(() => {
        // Always ensure menu is visible regardless of device
        setMenuVisible(true);
        
        // Close mobile menu when resizing to desktop
        if (!isMobile) {
            setMenuOpen(false);
            document.body.style.transform = 'translateX(0)';
            document.body.style.transition = '';
        }
    }, [isMobile]);

    // Ensure header is always visible
    useEffect(() => {
        // Check if header is visible, if not, force it to be visible
        const checkHeaderVisibility = () => {
            const headerElement = document.querySelector('.header-container');
            if (headerElement && window.getComputedStyle(headerElement).display === 'none') {
                headerElement.style.display = 'block';
            }
        };
        
        // Run on mount and periodically
        checkHeaderVisibility();
        const intervalId = setInterval(checkHeaderVisibility, 1000);
        
        return () => {
            clearInterval(intervalId);
            document.body.style.transform = 'translateX(0)';
            document.body.style.transition = '';
        };
    }, []);

    const toggleMenu = useCallback(() => {
        if (isMobile) {
            setMenuOpen(prev => !prev);
        }
    }, [isMobile]);

    // Render Home01 directly for the root path, otherwise use Outlet
    const isRootPath = location.pathname === '/';

    return (
        <>
            <Header
                ref={menuRef}
                toggleMenu={toggleMenu}
                isMobile={isMobile}
                menuVisible={menuVisible}
                menuOpen={menuOpen}
                setMenuOpen={setMenuOpen}
            />
            {isRootPath ? <Home01 /> : <Outlet />}
            <SectionGridLines />
            {shouldShowFooter && <Footer />}
            {isMobile && <TestMobileMenu />}
        </>
    );
};

export default HomeLayout;
